/**
 * Eyebrow — mirrors aidea.templateengine/src/slides/components/Eyebrow
 * Small uppercase label, accent color.
 */
import React from "react";

/* eslint-disable react/prop-types */

export function Eyebrow({ children, style }) {
  return (
    <span
      className="atomic-eyebrow"
      style={{
        display: "block",
        fontFamily: "var(--font-body)",
        fontSize: "var(--text-sm)",
        fontWeight: 600,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "var(--color-text-accent)",
        lineHeight: 1.4,
        ...style,
      }}
    >
      {children}
    </span>
  );
}

export default Eyebrow;
